import Vue from 'vue';
import App from './App.vue';
import router from './router/router';
import store from './store/store';
import './registerServiceWorker';
import Notifications from 'vue-notification';
import VueI18n from 'vue-i18n';
import VueCurrencyInput from 'vue-currency-input';
import VueCountdown from '@chenfengyuan/vue-countdown';
import vueCountryRegionSelect from 'vue-country-region-select'
Vue.use(vueCountryRegionSelect);

Vue.use(VueCurrencyInput);

Vue.use(VueI18n);
Vue.use(Notifications);
function loadLocaleMessages() {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i);
  const messages = {};
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      // @ts-ignore
      messages[locale] = locales(key);
    }
  });
  return messages;
}

const i18n = new VueI18n({
      locale: 'es',
      fallbackLocale: 'es',
      messages: loadLocaleMessages(),
});

import BootstrapVue from 'bootstrap-vue';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import './assets/css/fontawesome/css/all.css';
import './assets/css/style.css';
import Popover from 'vue-js-popover';

Vue.use(Popover, { tooltip: true });

Vue.config.productionTip = false;
Vue.use(BootstrapVue);

Vue.use(require('vue-moment'));
Vue.component(VueCountdown.name, VueCountdown);

import VModal from 'vue-js-modal';

Vue.filter('currency', (value: any) => {
    if (typeof value !== "number") {
        return value;
    }
    const formatter = new Intl.NumberFormat('es-es', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2,
    });
    return formatter.format(value / 100);
});

Vue.filter('usdcurrency', (value: any) => {
    if (typeof value !== "number") {
        return value;
    }
    const formatter = new Intl.NumberFormat('en-us', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
    });
    return formatter.format(value / 100);
});

Vue.filter('golagolcurrency', (value: any) => {
    if (typeof value !== "number") {
        return value;
    }
    const formatter = new Intl.NumberFormat('es-es', {
        style: 'currency',
        currency: 'GCC',
        minimumFractionDigits: 2,
    });
    return formatter.format(value / 100);
});

Vue.use(VModal);

const vm = new Vue({
  router,
  i18n,
  store,
  render: (h) => h(App),
}).$mount('#app');

export { vm };
